module.exports = __webpack_public_path__ + "LGFabout-2.a123b67f.png";